export default __webpack_public_path__ + "static/media/VID-20220612-WA0002.79bbdeb2.mp4";